import create from 'zustand';
import {
  candidateIdTypes,
  parentIdTypes
} from '@cont/OfflineCentres/constants';

const initalPostPaymentForm = {
  stepNum: 1,
  isFormSubmitted: false,
  fullName: '',
  phoneNum: '',
  class: '',
  examCgpa: '',
  bloodGroup: '',
  candidatePhoto: '',
  candidateId: '',
  candidateMarksheet: '',
  candidateIdType: candidateIdTypes[0],
  candidateIdNumber: '',
  parentId: '',
  parentIdType: parentIdTypes[0],
  parentIdNumber: '',
  parentFullName: '',
  parentPhoneNum: '',
  addressLine1: '',
  addressLine2: '',
  pincode: '',
  city: '',
  state: '',
  localAddressLine1: '',
  localAddressLine2: '',
  localPincode: '',
  localCity: '',
  localState: '',
  isLocalAddressSame: false
};

const useOfflineCentresStore = create((set) => ({
  cmsData: null,
  cities: null,
  cityUID: null,
  pricingData: null,
  subscriptionUID: null,
  discountedPricing: null,
  postPaymentForm: { ...initalPostPaymentForm },
  setPostPaymentFormState: (updatedState) => {
    set((state) => {
      const candidateIdType =
        updatedState.candidateIdType || state.postPaymentForm.candidateIdType;
      let parentIdType =
        updatedState.parentIdType ||
        state.postPaymentForm.parentIdType ||
        parentIdTypes[0];
      if (typeof parentIdType === 'string') {
        parentIdType = parentIdTypes.filter(
          (id) => id.value === parentIdType
        )?.[0];
      }
      return {
        ...state,
        postPaymentForm: {
          ...state.postPaymentForm,
          ...updatedState,
          candidateIdType,
          parentIdType
        }
      };
    });
  }
}));

export default useOfflineCentresStore;
